import React from 'react';
import { useChatContext } from 'stream-chat-react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import TagIcon from '@mui/icons-material/Tag';
import { TeamEditModal } from '../Modals';

export const TeamChannelHeader = () => {
  const { channel } = useChatContext();
  return (
    <Grid container direction='row' justifyContent='flex-start' alignItems='center' spacing={0} sx={{ pl: 2, pr: 2, backgroundColor: 'white', height: 62, boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.1)', overflowX: 'auto', flexWrap: 'nowrap'}}>
      <Box sx={{ width: '60px', textAlign: 'center', mr: 1}}>
        <Chip size='small' label={'Group'} variant='outlined' color='info'/>
      </Box>
      <TagIcon color='info' sx={{mr: 1}}/>
      <Typography sx={{ minWidth: 'max-content'}} variant='h6'>{channel && channel.data && channel.data.name && typeof channel.data.name === 'string' && channel.data.name}</Typography>
      <Box sx={{ flexGrow: 1 }}/>
      <TeamEditModal channel={channel}/>
    </Grid>
  );
};
